import { useDispatch } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react';
import 'flatpickr/dist/flatpickr.min.css';
import { HiDotsHorizontal } from "react-icons/hi";

import { CustomLoader } from '../../../services/Reducer'
import Add_table from '../Vessel_Type/Add_table.js'
import Edit from '../Vessel_Type/Edit.js'
import Delete from '../../../components/Delete.js';
import apiClient from '../../../api/apiClient.js';
import { RiFileExcel2Fill } from 'react-icons/ri';
import authServices from '../../../services/AuthServices.js';


const VesselTypeTable = () => {

  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
  };


  //***************************************  this is for Edit modal *************************************************

  const [editModal, seteditModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const toggleeditModal = (invoiceId) => {
    setSelectedInvoice(invoiceId);
    seteditModal(!editModal);
  };


  //**************************** GetAll Data Fetch ka function *******************************************************

  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const loader = (display) => { dispatch(CustomLoader(display)) }

  const [Records, setRecords] = useState([]);

  const [currentPage, setCurrentPage] = useState(0); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total pages
  const itemsPerPage = 10; // Number of items per page


  const token = authServices.getToken();
  const fetchRecords = async (page) => {

    try {

      loader('enable');
      const response = await apiClient.get(`/api/admin/vessel_type/getAll?pageNumber=${page}&pageSize=${itemsPerPage}`, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {

        setRecords(response.data.data.records);
        setTotalPages(response.data.data.totalPages);

      }
      else {
        console.log(response.data.message)
      }
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }

    finally {
      loader('disable');
    }


  };



  // Pagination handlers
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage); // Update page
  };

  // Pagination component
  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];

    // Add first 2 pages
    for (let i = 0; i < Math.min(2, totalPages); i++) {
      pages.push(i);
    }

    // Add the current page if it's between first 2 and last 2 pages
    if (currentPage > 1 && currentPage < totalPages - 2) {
      pages.push(currentPage);
    }

    // Add last 2 pages
    for (let i = Math.max(totalPages - 2, 2); i < totalPages; i++) {
      pages.push(i);
    }


    // Previous button condition
    const previousPage = () => {
      if (currentPage > 0) {
        onPageChange(currentPage - 1);
      }
    };

    // Next button condition
    const nextPage = () => {
      if (currentPage < totalPages - 1) {
        onPageChange(currentPage + 1);
      }
    };

    // pagination Buttons Next & Previous
    return (
      <nav>
        <ul className="pagination">

          {/* Previous Button */}
          <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
            <button onClick={previousPage} className="page-link">
              Previous
            </button>
          </li>

          {pages.map((page) => (
            <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
              <button onClick={() => onPageChange(page)} className="page-link">
                {page + 1}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
            <button onClick={nextPage} className="page-link">
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  // *******************************************************************************************************************
  // Delete List Records


  const [openModal, setOpenModal] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  const handleDeleteClick = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setOpenModal(true); // Open the modal when delete is clicked
  };

  const handleConfirmDelete = async (invoiceId) => {
    try {
      loader('enable');
      const response = await apiClient.delete(`/api/admin/vessel_type/${selectedInvoiceId}`, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {

      }
      else {
        console.log(response.data.message)
      }

    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    } finally {
      fetchRecords(currentPage);
      loader('disable');
      setOpenModal(false);
    }
  };
  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal if user cancels
  };

  // Excel File Downlode

  const ExcelFileDownload = async () => {
    try {
      loader('enable');
      const response = await apiClient.get(`/api/admin/vessel_type/download`, {
        responseType: 'blob',

        headers: {
          'access_token': token,
        },

      });
      // if (response.data.Status === "SUCCESS") {

      // Create a link to download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Set the file name you want to download as
      link.setAttribute('download', 'vessel_type.xlsx'); // Change the file name if needed
      document.body.appendChild(link);
      link.click();

      // Clean up the link element
      link.remove();
      // }
      // else {
      //   console.log(response.data.message)
      // }

    } catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      loader('disable');
    }
  };

  useEffect(() => {

    fetchRecords(currentPage);

  }, [currentPage]);


  // **********************************************************************************************************************

  const displayedData = Records;

  // *************************************************  This For CheckBox  **********************************************************

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = displayedData.map(invoice => invoice.id);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (event, id) => {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, id]);
    } else {
      setSelectedItems(selectedItems.filter(item => item !== id));
    }
  };

  return (

    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <div className="mb-4">

                <Add_table show={showModal} toggle={toggleModal} refreshData={fetchRecords} AddcurrentPage={currentPage} />
                <Edit edit={editModal} toggle_Edit={toggleeditModal} invoiceId={selectedInvoice}
                  refreshData={fetchRecords} AddcurrentPage={currentPage} />

                <button
                  onClick={toggleModal}
                  type="button"
                  className="btn btn-light waves-effect waves-light"
                >

                  + ADD
                </button>

              </div>
              <div className="d-flex align-items-center gap-1 mb-4">
                <div className="input-group mt-2">

                  <button className="input-group-text" onClick={ExcelFileDownload}>
                    < RiFileExcel2Fill />
                  </button>
                </div>
                {/* <div className="dropdown">
                    <a
                      className="btn btn-link text-muted py-1 font-size-16 shadow-none dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      < HiDotsHorizontal />
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <a className="dropdown-item" href="#">
                          Action
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Another action
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Something else here
                        </a>
                      </li>
                      
                    </ul>
                  </div> */}
              </div>
            </div>
            {/* end row */}
            <div className="table-responsive ">
              <table
                className="table table-bordered align-middle datatable dt-responsive table-check nowrap text-center"
                style={{
                  borderCollapse: "collapse",
                  borderSpacing: "0 8px",
                  width: "100%"
                }}
              >
                <thead className='table-light'>
                  <tr className="bg-transparent">
                    {/* <th style={{ width: 5 }}>

                      <div className="form-check font-size-16">
                        <input
                          type="checkbox"
                          name="check"
                          className="form-check-input"
                          id="checkAll"
                          onChange={handleSelectAll}
                          checked={selectedItems.length === displayedData.length}
                        />
                        <label className="form-check-label" htmlFor="checkAll" />
                      </div>

                    </th> */}
                    {/* <th style={{ width: 100 }}>_ID_</th> */}
                    <th style={{ width: 100 }}>Name</th>

                    <th style={{ width: 10 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedData.length > 0 ? (
                    <>
                      {displayedData.map(invoice => (
                        <tr key={invoice.id}>
                          {/* <td>

                            <div className="form-check font-size-16">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`check-${invoice.id}`}
                                checked={selectedItems.includes(invoice.id)}
                                onChange={(e) => handleSelectItem(e, invoice.id)}
                              />
                              <label className="form-check-label" htmlFor={`check-${invoice.id}`} />
                            </div>

                          </td> */}
                          {/* <td>
                            <a
                              className="text-body fw-medium"
                            >{invoice.id}
                            </a>
                          </td> */}
                          <td>{invoice?.name || '--'}</td>

                          <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                < HiDotsHorizontal />
                              </button>
                              <ul className="dropdown-menu dropdown-menu-end">
                                <li>

                                  <button
                                    onClick={() => toggleeditModal(invoice.id)}
                                    type="button"
                                    className="btn waves-effect waves-light dropdown-item"
                                  >

                                    <i className="dropdown-item" /> Edit
                                  </button>

                                </li>

                                <li>
                                  <button className="btn waves-effect waves-light dropdown-item"
                                    onClick={() => handleDeleteClick(invoice.id)}
                                  >
                                    Delete
                                  </button>
                                  <Delete
                                    open={openModal}
                                    handleClose={handleCloseModal}
                                    handleConfirm={handleConfirmDelete}
                                    message="Are you sure you want to delete this invoice ?"
                                  />
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={8}>
                        <p className="text-center" >Record Not Found</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* end table responsive */}
            <div className='d-flex flex-row justify-content-end'>
              Showing {currentPage + 1} In to {totalPages} Entries
            </div>
            {/* Pagination */}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />

          </div>
          {/* end card body */}
        </div>
        {/* end card */}
      </div>
      {/* end col */}
    </div>

  );
};

export default VesselTypeTable;
